import { render, staticRenderFns } from "./ParametrosAssinatura.vue?vue&type=template&id=4de62816&"
import script from "./ParametrosAssinatura.vue?vue&type=script&lang=js&"
export * from "./ParametrosAssinatura.vue?vue&type=script&lang=js&"
import style0 from "./ParametrosAssinatura.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports